import * as userActions from '../user/actions';
import * as lawsNPAsActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsNPAsReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsNPAsActions.SET_LAWS_NPAS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsNPAsActions.SET_LAWS_NPAS_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsNPAsActions.SET_LAWS_NPAS:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsNPAsActions.ABORT_NPAS_REQUEST:
            return initialState;

        case lawsNPAsActions.CLEAN_LAWS_NPAS:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsNPAs/reducer.js